import Api from "./api.service";

class Delete {
  static getDeleteSummary(resource, recordSlug, tenantSlug, apiVersion = "v1") {
    var params;

    if (apiVersion === "v1") {
      switch (resource) {
        case "customers":
          params = { include: "owned_purchases,assigned_purchases" };
          break;
        case "customer_groups":
          params = { include: "customer_groupings,discounts" };
          break;
        case "purchases":
          params = { include: "product.product_bundles.bundle_usages" };
          break;
        case "out_of_bundle_purchases":
          params = {};
          break;
        case "products":
          params = { include: "purchases" };
          break;
        case "bundles":
          params = { include: "product_bundles,templates_bundles" };
          break;
        case "license_bundles":
          params = { include: "product_license_bundles,templates_license_bundles" };
          break;
        case "product_metadata_types":
          params = { include: "product_metadata_items,templates_features" };
          break;
        case "product_groups":
          params = { include: "product_groupings,discounts" };
          break;
        case "invoices":
          params = {};
          break;
        default:
          params = {};
      }
    } else {
      switch (resource) {
        case "bundles":
          params = {};
          break;
        case "license_bundles":
          params = {};
          break;
        case "orders":
          params = {};
          break;
        default:
          params = {};
      }
    }

    return Api.get(`/api/${apiVersion}/tenants/${tenantSlug}/${resource}/${recordSlug}`, { params });
  }

  static deleteRecord(resource, recordSlug, tenantSlug, apiVersion = "v1") {
    return Api.delete(`/api/${apiVersion}/tenants/${tenantSlug}/${resource}/${recordSlug}`);
  }
}

const DeleteService = Object.freeze(Delete);
export default DeleteService;
